import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import moment from 'moment';
import { get } from 'lodash/fp';
import FoodStoplight from '../../../../../components/FoodStoplight';
import Image from '../../../../../components/reservations/Image';
import { InventorySnapshotType } from '../../../../../interfaces/reservation';
import { StringOrNumberType } from '../../../../../interfaces';
import LinkedInventoryDetails from '../../../../../components/LinkedInventoryDetails';

export const ItemGroup = styled.div`
  max-width: 400px;
  padding: 3px 0;
`;

export const ItemLabel = styled.label`
  width: 75px;
  display: inline-block;
  text-transform: none;
  font-size: 12px;
  margin-right: 10px;
  font-weight: normal;
  color: #8e8e93;
`;

const ItemName = styled.h4`
  margin: 0;
`;

export const ItemValue = styled.div`
  display: inline-block;
  text-align: left;
  text-transform: none;
  font-size: 13px;
  font-weight: normal;
`;

const ImageWrapper = styled.div`
  position: relative;
  display: inline-block;
  border: 1px solid;
  border-color: #adadad;
  padding: 3px;
`;

const Section = styled.div`
  display: inline-block;
  vertical-align: top;
`;

const ROItemDetails = ({ data }) => (
  <div>
    <ImageWrapper style={{ marginRight: 20 }}>
      <Image alt="photo" image={data.photo} style={{ borderRadius: 5 }} />
    </ImageWrapper>
    <Section key="details">
      <ItemName>{data.name}</ItemName>
      {data.healthLevel > 0 && (
        <ItemGroup key="stoplight" style={{ height: '25px' }}>
          <FoodStoplight value={data.healthLevel} />
        </ItemGroup>
      )}
      {data.description && (
        <ItemGroup key="desc" style={{ margin: '10px 0' }}>
          <ItemValue>{data.description}</ItemValue>
        </ItemGroup>
      )}
      <ItemGroup key="isVisible" style={{ margin: '10px 0' }}>
        <ItemLabel>Status:</ItemLabel>
        <ItemValue>{data.isVisible ? 'Show' : 'Hide'}</ItemValue>
      </ItemGroup>
      {get('inventorySnapshot', data) && (
        <LinkedInventoryDetails snapshot={get('inventorySnapshot', data)} />
      )}
      <ItemGroup key="createdAt" style={{ margin: '10px 0' }}>
        <ItemLabel>Date Created:</ItemLabel>
        <ItemValue>{moment(data.createdAt).format('MM/DD/YYYY')}</ItemValue>
      </ItemGroup>
      {data.updatedAt && (
        <ItemGroup key="updatedAt" style={{ margin: '10px 0' }}>
          <ItemLabel>Last Updated:</ItemLabel>
          <ItemValue>{moment(data.updatedAt).format('MM/DD/YYYY')}</ItemValue>
        </ItemGroup>
      )}
    </Section>
  </div>
);

ROItemDetails.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    healthLevel: StringOrNumberType.isRequired,
    isVisible: PropTypes.bool.isRequired,
    photo: PropTypes.string,
    createdAt: PropTypes.string.isRequired,
    updatedAt: PropTypes.string,
    inventorySnapshot: InventorySnapshotType
  }).isRequired
};

export default ROItemDetails;
